"use strict";

export const serviceInput = (data) => ({
    value: data.value,
    isPerStay: data.isPerStay,
    isPerPerson: data.isPerPerson,
    isPerNight: data.isPerNight,
    isMandatory: data.isMandatory,
    guests: 1,
    nights: 1,
    quantitySelector: null,
    quantityInputClass: data.class,
    init() {
        if (this.isMandatory) {
            let checkbox = this.$el.querySelector('input[type="checkbox"]');
            if (checkbox !== null) {
                checkbox.checked = true;
                checkbox.addEventListener('click', function (event) {
                    event.preventDefault();
                });
                checkbox.closest('label').querySelector('span.yith-wcbk-checkbox__checkbox').style.display = 'none';
            }
        }
        this.quantitySelector = this.$el.querySelector(`.${this.quantityInputClass}`);
    },
    calculateValue() {
        if (this.isPerStay) {
            this.value = 1;
            return;
        }

        this.value = (this.isPerPerson ? this.guests : 1) * (this.isPerNight ? this.nights : 1);
        if (this.isMandatory) {
            this.value = Math.max(this.value, 1);
        }
        if (this.quantitySelector !== null) {
            jQuery(`.${this.quantityInputClass}`).val(this.value).trigger('change')
        }
    },
    updatePeople(guests) {
        this.guests = guests;
        this.calculateValue();
    },
    updateNights(nights) {
        this.nights = nights;
        this.calculateValue();
    }
})